import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Toolstack from "./Toolstack";

const skillGroups = [
    {
        title: "Languages",
        items: ["Java", "Python", "JavaScript", "TypeScript", "C#", "C++", "SQL", "PowerShell"],
    },
    {
        title: "Backend & Systems",
        items: ["Spring Boot", "Microservices", "Apache Kafka", "REST APIs", "gRPC", "RAG Systems", "Distributed Systems"],
    },
    {
        title: "Cloud & Infra",
        items: ["AWS", "Docker", "Linux", "Git", "VMware vSphere", "CI/CD", "PostgreSQL", "MongoDB"],
    },
    {
        title: "AI & Applied ML",
        items: ["Generative AI", "LLM Integration", "LangChain", "Spring AI", "Multi-Agent Orchestration", "Machine Learning"],
    },
];

function Skill() {
    return (
        <Container fluid className="project-section">
            <Particle />
            <Container>
                <div className="project-hero section-hero-left">
                    <p className="project-kicker">Skills</p>
                    <h1 className="project-heading">
                        Resume-aligned technologies across systems, backend, cloud, and AI.
                    </h1>
                    <p className="project-subheading">
                        The stack below reflects the tools and technologies most consistently used across my recent work and projects.
                    </p>
                </div>

                <h1 className="section-heading">
                    <strong className="purple">Core </strong> Areas
                </h1>

                <Row style={{ justifyContent: "center", paddingBottom: "18px" }}>
                    {skillGroups.map((group) => (
                        <Col md={6} className="project-card" key={group.title}>
                            <Card className="project-card-view skill-summary-card">
                                <Card.Body>
                                    <Card.Title>{group.title}</Card.Title>
                                    <div className="skill-chip-grid">
                                        {group.items.map((item) => (
                                            <span key={item} className="skill-chip">
                                                {item}
                                            </span>
                                        ))}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <h1 className="section-heading">
                    <strong className="purple">Technology </strong> Stack
                </h1>

                <Techstack />

                <h1 className="section-heading">
                    <strong className="purple">Tooling</strong> & workflow
                </h1>
                <Toolstack />

                <Github />
            </Container>
        </Container>
    );
}

export default Skill;
